<template>
  <v-text-field
    :label="label"
    prepend-inner-icon="mdi-magnify"
    v-model="location_text"
    outlined
    background-color="#FFF"
    hide-details
    ref="autocomplete"
    placeholder
    :error="error"
    :error-messages="errorMessages"
    onfocus="this.select();"
  ></v-text-field>
</template>

<script>
import _ from "lodash";
import {
  COUNTRY_CODE,
  COUNTRY_BOUNDS,
  MAP_CENTER,
  DEFAULT_LOCATION
} from "@/config";

export default {
  props: ["label", "value", "error", "errorMessages"],
  data: () => ({
    autocomplete: null
  }),

  mounted: function() {
    this.$google.then(google => {
      let input = this.$refs.autocomplete.$el.querySelector("input");
      let options = {
        bounds: {
          ...COUNTRY_BOUNDS
        },
        componentRestrictions: {
          country: [COUNTRY_CODE]
        },
        types: ["geocode"],
        fields: [
          "geometry",
          "place_id",
          "formatted_address",
          "address_components"
        ],
        strictBounds: true
      };

      this.autocomplete = new google.maps.places.Autocomplete(input, options);

      this.autocomplete.addListener("place_changed", () => {
        this.onPlaceChanged(this.autocomplete.getPlace());
      });
    });
  },

  methods: {
    onPlaceChanged: function(response) {
      let location = {
        ...response.geometry.location.toJSON(),
        ...response.geometry.viewport.toJSON(),
        formatted_address: response.formatted_address,
        place_id: response.place_id,
        zoom: this.calculateZoom(response),
        address_components: response.address_components
      };

      this.$emit("input", location);
    },

    calculateZoom: function(response) {
      let globe_width = 256; // a constant in Google's map projection
      let pixel_width = 256;
      let { east, west } = response.geometry.viewport.toJSON();
      let angle = east - west;
      if (angle < 0) angle += 360;
      // let zoom = Math.round(Math.log(pixel_width * 360 / angle / globe_width) / Math.LN2);
      let zoom = Math.ceil(
        Math.log((pixel_width * 360) / angle / globe_width) / Math.LN2
      );
      return Math.min(zoom, 21);
    }
  },
  computed: {
    location_text: {
      get: function() {
        let v = _.get(this.value, "formatted_address");
        return v;
      },
      set: function(v) {
        return;
      }
    }
  }
};
</script>